import { FC, PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

/**
 * The table message container component.
 */
export const MessageContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className={classNames(styles.MessageContainer, "message-container")} role="status" aria-live="polite">
      {children}
    </div>
  );
};
